(function ($) {
  'use strict';

  var subNavOpenLabel = 'Expand ';
  var subNavCloseLabel = 'Close ';
  var openLabel = subNavOpenLabel + 'Sub-Navigation';
  var closeLabel = subNavCloseLabel + 'Sub-Navigation';
  var $desktopSelector = $('.desktop-nav');
  var $buttonParent = $('li.menu-item');
  var $buttonWrapper = $('.cc--utility-menu .utility-button-wrapper', $desktopSelector);
  var $navItems = $('.information-for-toggle', $desktopSelector);
  var $submenu = $('.submenu', $desktopSelector);

  var initUtilityDropDownMenu = function () {

    var config = {
      interval: 100,
      sensitivity: 6,
      timeout: 0,
      over: handlerIn,
      out: handlerOut
    };

    $.mediaquery('bind', 'utilityDropDownMenu', '(min-width: 1024px)', {
      enter: function () {
        // desktop - trigger on hover events for submenu
        $buttonWrapper.hoverIntent(config);
      },
      leave: function () {
        // mobile - unbind on hover events for submenu
        $buttonWrapper.off('mouseenter mouseleave');
      }
    });
  };

  // on mouseenter - desktop
  var handlerIn = function () {
    $(this).parent($buttonParent).addClass('on-hover');
    $(this).find($navItems).addClass('is-open').attr({'aria-label': closeLabel, 'aria-expanded': true});
    $(this).find($submenu).show().attr('aria-hidden', false);
  };

  // on mouseleave - desktop
  var handlerOut = function () {
    $(this).parent($buttonParent).removeClass('on-hover');
    $(this).find($navItems).removeClass('is-open').attr({'aria-label': openLabel, 'aria-expanded': false});
    $(this).find($submenu).hide().attr('aria-hidden', true);
  };

  $buttonWrapper.find('button').focus(function () {
    $(this).addClass('is-focused');
  });

  $buttonWrapper.find('.submenu li:last-child a').blur(function () {
    $(this).parent().parent().siblings().find('button').removeClass('is-focused');
    $(this).closest('.submenu').attr('aria-hidden', true);
    $(this).closest('.submenu').hide();
  });

  $navItems.focus(function () {
    $(this).parent().next().show().attr('aria-hidden', false);
  });

  window.DP.behaviors.utilityDropDownMenu = {
    attach: function (context) {
      once('utilityDropDownMenu', '.utility-nav-container .cc--utility-menu', context)
        .forEach((e) => {
          initUtilityDropDownMenu.apply(e);
        });
      // $(context).find('.utility-nav-container .cc--utility-menu').once('utilityDropDownMenu').each(function () {
      //   initUtilityDropDownMenu.apply(this);
      // });
    }
  };

}(jQuery));
